var _ellipse, _g, _path, _path2, _g2, _path3, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVerificationIntroMobile = function SvgVerificationIntroMobile(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 240,
    viewBox: "0 0 324 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    rx: 119.998,
    ry: 100.801,
    transform: "matrix(-1 0 0 1 161.998 134.398)",
    fill: "url(#paint0_linear_4954_9494)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4954_9494)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.697 55.5038C263.418 56.0146 264.348 56.1422 265.177 55.8286C266.005 55.5128 266.615 54.805 266.798 53.9471C268.745 44.799 273.467 21.6445 275.239 13.323C275.373 12.6958 275.149 12.044 274.656 11.6251C274.163 11.2063 273.48 11.0853 272.871 11.3115C263.479 14.788 234.554 25.6406 222.732 30.0153C221.981 30.293 221.493 31.0143 221.517 31.805C221.544 32.5979 222.077 33.2856 222.846 33.5163C228.148 35.1022 235.107 37.3086 235.107 37.3086C235.107 37.3086 238.36 47.1309 240.055 52.126C240.268 52.7532 240.759 53.246 241.406 53.4162C242.051 53.5842 242.741 53.4072 243.223 52.9525C245.947 50.381 250.158 46.4051 250.158 46.4051C250.158 46.4051 258.159 52.2716 262.697 55.5038Z",
    fill: "#F7F8F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.697 55.5038C263.418 56.0146 264.348 56.1422 265.177 55.8286C266.005 55.5128 266.615 54.805 266.798 53.9471C268.745 44.799 273.467 21.6445 275.239 13.323C275.373 12.6958 275.149 12.044 274.656 11.6251C274.163 11.2063 273.48 11.0853 272.871 11.3115C263.479 14.788 234.554 25.6406 222.732 30.0153C221.981 30.293 221.493 31.0143 221.517 31.805C221.544 32.5979 222.077 33.2856 222.846 33.5163C228.148 35.1022 235.107 37.3086 235.107 37.3086C235.107 37.3086 238.36 47.1309 240.055 52.126C240.268 52.7532 240.759 53.246 241.406 53.4162C242.051 53.5842 242.741 53.4072 243.223 52.9525C245.947 50.381 250.158 46.4051 250.158 46.4051C250.158 46.4051 258.159 52.2716 262.697 55.5038V55.5038ZM238.035 36.0677L241.796 48.4726L242.631 40.617C242.631 40.617 257.162 27.511 265.445 20.0407C265.687 19.8212 265.721 19.4538 265.519 19.1962C265.32 18.9386 264.953 18.8782 264.677 19.0529C255.077 25.1837 238.035 36.0677 238.035 36.0677Z",
    fill: "url(#paint1_linear_4954_9494)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.1994 182.801C60.2776 182.801 49.7998 193.279 49.7998 206.2C49.7998 217.042 57.1837 226.142 67.1935 228.794L73.1994 234.8L79.2053 228.794C89.2152 226.142 96.5991 217.042 96.5991 206.2C96.5991 193.279 86.1212 182.801 73.1994 182.801Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1994 182.801C60.2776 182.801 49.7998 193.279 49.7998 206.2C49.7998 217.042 57.1837 226.142 67.1935 228.794L73.1994 234.8L79.2053 228.794C89.2152 226.142 96.5991 217.042 96.5991 206.2C96.5991 193.279 86.1212 182.801 73.1994 182.801ZM73.1994 188.001C77.5154 188.001 80.9993 191.485 80.9993 195.801C80.9993 200.116 77.5154 203.6 73.1994 203.6C68.8835 203.6 65.3996 200.116 65.3996 195.801C65.3996 191.485 68.8835 188.001 73.1994 188.001ZM73.1994 225.18C66.6995 225.18 60.9536 221.852 57.5997 216.808C57.6777 211.634 67.9995 208.8 73.1994 208.8C78.3733 208.8 88.7212 211.634 88.7992 216.808C85.4452 221.852 79.6993 225.18 73.1994 225.18Z",
    fill: "url(#paint2_linear_4954_9494)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4954_9494)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 71.9988,
    ry: 60.0003,
    transform: "matrix(-1 0 0 1 161.998 122.399)",
    fill: "url(#paint3_linear_4954_9494)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4994 122.399C90.4994 155.178 122.421 181.899 161.998 181.899C201.575 181.899 233.497 155.178 233.497 122.399C233.497 89.6191 201.575 62.8984 161.998 62.8984C122.421 62.8984 90.4994 89.6191 90.4994 122.399Z",
    stroke: "url(#paint4_radial_4954_9494)",
    strokeOpacity: 0.2,
    shapeRendering: "crispEdges"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M219.232 66.553C219.867 66.0214 219.952 65.0753 219.42 64.44C218.888 63.8046 217.942 63.7205 217.307 64.2521L219.232 66.553ZM205.166 110.3L203.989 109.371L205.166 110.3ZM128.181 124.458L129.173 125.584L129.173 125.584L128.181 124.458ZM101.315 189.645C101.315 190.473 101.986 191.145 102.815 191.145C103.643 191.145 104.315 190.473 104.315 189.645H101.315ZM214.829 66.4629C214.228 67.0336 214.204 67.9831 214.775 68.5836C215.346 69.1841 216.295 69.2083 216.896 68.6376L214.829 66.4629ZM211.323 74.8604C211.826 74.2021 211.7 73.2608 211.042 72.7579C210.383 72.255 209.442 72.381 208.939 73.0393L211.323 74.8604ZM205.221 78.51C204.793 79.2194 205.021 80.1413 205.731 80.5691C206.44 80.9969 207.362 80.7686 207.79 80.0592L205.221 78.51ZM203.969 87.524C204.295 86.7624 203.942 85.8807 203.18 85.5547C202.419 85.2286 201.537 85.5816 201.211 86.3432L203.969 87.524ZM198.928 92.5429C198.683 93.3342 199.126 94.1744 199.917 94.4194C200.709 94.6644 201.549 94.2215 201.794 93.4302L198.928 92.5429ZM199.95 101.572C200.062 100.751 199.488 99.9947 198.667 99.8823C197.846 99.7699 197.09 100.344 196.977 101.165L199.95 101.572ZM196.687 107.914C196.75 108.74 197.471 109.358 198.297 109.295C199.123 109.231 199.741 108.51 199.678 107.684L196.687 107.914ZM202.021 111.335C201.335 111.798 201.154 112.731 201.618 113.417C202.081 114.104 203.014 114.284 203.7 113.821L202.021 111.335ZM208.07 108.581C208.441 107.84 208.14 106.939 207.399 106.569C206.658 106.198 205.757 106.499 205.387 107.24L208.07 108.581ZM203.991 103.239C204.755 103.56 205.634 103.2 205.954 102.436C206.275 101.672 205.916 100.793 205.152 100.473L203.991 103.239ZM199.183 99.2682C198.356 99.2132 197.641 99.8386 197.586 100.665C197.531 101.492 198.157 102.207 198.983 102.262L199.183 99.2682ZM191.721 102.4C192.547 102.331 193.16 101.606 193.091 100.781C193.022 99.9552 192.297 99.3418 191.471 99.4107L191.721 102.4ZM185.791 100.076C184.971 100.196 184.404 100.958 184.525 101.778C184.646 102.598 185.408 103.164 186.227 103.044L185.791 100.076ZM178.926 104.357C179.736 104.186 180.256 103.391 180.086 102.58C179.915 101.77 179.12 101.25 178.31 101.42L178.926 104.357ZM172.767 102.695C171.963 102.895 171.474 103.71 171.674 104.513C171.875 105.317 172.689 105.806 173.493 105.606L172.767 102.695ZM166.32 107.572C167.114 107.335 167.565 106.499 167.328 105.706C167.091 104.912 166.255 104.461 165.461 104.698L166.32 107.572ZM160.047 106.415C159.262 106.679 158.839 107.529 159.103 108.314C159.367 109.1 160.218 109.522 161.003 109.259L160.047 106.415ZM154.012 111.791C154.784 111.49 155.165 110.62 154.865 109.848C154.564 109.077 153.694 108.695 152.922 108.996L154.012 111.791ZM147.667 111.164C146.908 111.496 146.561 112.38 146.892 113.139C147.224 113.898 148.108 114.245 148.867 113.913L147.667 111.164ZM142.173 117.086C142.91 116.706 143.199 115.801 142.819 115.065C142.439 114.329 141.535 114.04 140.798 114.419L142.173 117.086ZM135.788 117.195C135.077 117.62 134.845 118.541 135.27 119.252C135.695 119.964 136.616 120.196 137.327 119.771L135.788 117.195ZM131.267 123.859C131.923 123.352 132.043 122.41 131.537 121.755C131.03 121.099 130.088 120.979 129.432 121.486L131.267 123.859ZM124.867 125.481C124.273 126.059 124.259 127.008 124.837 127.602C125.414 128.197 126.363 128.21 126.958 127.633L124.867 125.481ZM121.562 133.594C122.078 132.946 121.971 132.002 121.323 131.486C120.674 130.97 119.731 131.078 119.215 131.726L121.562 133.594ZM115.516 136.838C115.061 137.531 115.253 138.461 115.946 138.915C116.638 139.37 117.568 139.178 118.023 138.485L115.516 136.838ZM113.99 145.468C114.364 144.729 114.067 143.827 113.328 143.453C112.589 143.079 111.686 143.375 111.313 144.115L113.99 145.468ZM108.697 149.837C108.381 150.603 108.747 151.48 109.513 151.795C110.279 152.11 111.156 151.745 111.471 150.979L108.697 149.837ZM108.753 158.602C108.995 157.809 108.549 156.971 107.756 156.729C106.964 156.488 106.126 156.934 105.884 157.726L108.753 158.602ZM104.249 163.783C104.059 164.59 104.558 165.397 105.364 165.588C106.171 165.778 106.979 165.279 107.169 164.473L104.249 163.783ZM105.621 172.44C105.748 171.621 105.186 170.855 104.368 170.729C103.549 170.602 102.783 171.164 102.657 171.983L105.621 172.44ZM101.875 178.193C101.794 179.018 102.397 179.751 103.221 179.832C104.046 179.913 104.78 179.31 104.861 178.486L101.875 178.193ZM104.355 186.601C104.378 185.773 103.724 185.084 102.896 185.062C102.068 185.04 101.379 185.693 101.356 186.521L104.355 186.601ZM217.307 64.2521C216.451 64.9682 215.625 65.7061 214.829 66.4629L216.896 68.6376C217.647 67.9234 218.426 67.2276 219.232 66.553L217.307 64.2521ZM208.939 73.0393C207.576 74.8234 206.339 76.6564 205.221 78.51L207.79 80.0592C208.854 78.2949 210.03 76.553 211.323 74.8604L208.939 73.0393ZM201.211 86.3432C200.311 88.4448 199.553 90.5248 198.928 92.5429L201.794 93.4302C202.388 91.5103 203.111 89.5283 203.969 87.524L201.211 86.3432ZM196.977 101.165C196.633 103.682 196.538 105.976 196.687 107.914L199.678 107.684C199.549 106.007 199.627 103.933 199.95 101.572L196.977 101.165ZM203.7 113.821C204.574 113.231 205.454 112.356 206.343 111.23L203.989 109.371C203.211 110.355 202.551 110.977 202.021 111.335L203.7 113.821ZM206.343 111.23C207.068 110.311 207.647 109.429 208.07 108.581L205.387 107.24C205.076 107.862 204.62 108.571 203.989 109.371L206.343 111.23ZM205.152 100.473C203.542 99.797 201.494 99.4223 199.183 99.2682L198.983 102.262C201.133 102.405 202.811 102.744 203.991 103.239L205.152 100.473ZM191.471 99.4107C189.67 99.5611 187.768 99.7846 185.791 100.076L186.227 103.044C188.151 102.761 189.99 102.545 191.721 102.4L191.471 99.4107ZM178.31 101.42C176.494 101.802 174.641 102.227 172.767 102.695L173.493 105.606C175.332 105.147 177.148 104.73 178.926 104.357L178.31 101.42ZM165.461 104.698C163.656 105.237 161.848 105.81 160.047 106.415L161.003 109.259C162.771 108.665 164.547 108.102 166.32 107.572L165.461 104.698ZM152.922 108.996C151.141 109.69 149.385 110.414 147.667 111.164L148.867 113.913C150.547 113.18 152.266 112.471 154.012 111.791L152.922 108.996ZM140.798 114.419C139.058 115.317 137.382 116.243 135.788 117.195L137.327 119.771C138.862 118.854 140.483 117.957 142.173 117.086L140.798 114.419ZM129.432 121.486C128.647 122.093 127.898 122.709 127.19 123.333L129.173 125.584C129.829 125.006 130.529 124.43 131.267 123.859L129.432 121.486ZM127.19 123.333C126.393 124.035 125.619 124.751 124.867 125.481L126.958 127.633C127.674 126.937 128.413 126.253 129.173 125.584L127.19 123.333ZM119.215 131.726C117.892 133.388 116.661 135.095 115.516 136.838L118.023 138.485C119.12 136.815 120.298 135.182 121.562 133.594L119.215 131.726ZM111.313 144.115C110.359 146.001 109.489 147.912 108.697 149.837L111.471 150.979C112.235 149.122 113.073 147.282 113.99 145.468L111.313 144.115ZM105.884 157.726C105.267 159.749 104.724 161.772 104.249 163.783L107.169 164.473C107.63 162.521 108.156 160.56 108.753 158.602L105.884 157.726ZM102.657 171.983C102.332 174.089 102.074 176.164 101.875 178.193L104.861 178.486C105.055 176.509 105.305 174.489 105.621 172.44L102.657 171.983ZM101.356 186.521C101.328 187.584 101.315 188.626 101.315 189.645H104.315C104.315 188.653 104.328 187.637 104.355 186.601L101.356 186.521Z",
    fill: "#C9CBC3"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4954_9494)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 142.841,
    y: 86.6875,
    width: 42.3148,
    height: 42.3148,
    rx: 21.1574,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.841,
    y: 86.6875,
    width: 42.3148,
    height: 42.3148,
    rx: 21.1574,
    fill: "#587300",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.998 99.0745V95.7852L159.612 100.171L163.998 104.557V101.267C167.627 101.267 170.577 104.217 170.577 107.846C170.577 108.954 170.303 110.006 169.809 110.916L171.41 112.517C172.265 111.168 172.77 109.568 172.77 107.846C172.77 103 168.844 99.0745 163.998 99.0745ZM163.998 114.425C160.369 114.425 157.419 111.475 157.419 107.846C157.419 106.739 157.694 105.686 158.187 104.776L156.586 103.175C155.731 104.524 155.227 106.125 155.227 107.846C155.227 112.692 159.152 116.618 163.998 116.618V119.907L168.384 115.521L163.998 111.135V114.425Z",
    fill: "#314000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.841,
    y: 84.6875,
    width: 46.3148,
    height: 46.3148,
    rx: 23.1574,
    stroke: "white",
    strokeWidth: 4,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4954_9494",
    x: 170.797,
    y: -4,
    width: 155.199,
    height: 155.199,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 40
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4954_9494"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4954_9494",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4954_9494",
    x: 73.999,
    y: 62.3984,
    width: 191.998,
    height: 168,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 24
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4954_9494"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4954_9494",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4954_9494",
    x: 122.841,
    y: 78.6875,
    width: 98.3145,
    height: 98.3164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4954_9494"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4954_9494",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4954_9494",
    x1: 59.2565,
    y1: 147.083,
    x2: 303.702,
    y2: 149.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#324101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#324101",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4954_9494",
    x1: 275.277,
    y1: 33.5987,
    x2: 241.18,
    y2: -41.9684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCBF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4954_9494",
    x1: 68.8925,
    y1: 218.783,
    x2: -40.6886,
    y2: 84.3235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#314000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C9C2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4954_9494",
    x1: 93.5381,
    y1: 4.6962,
    x2: 72.5161,
    y2: 120.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_4954_9494",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(173.603 149.985) rotate(-144.583) scale(102.586 123.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161F00",
    stopOpacity: 0
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVerificationIntroMobile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "verification-intro-mobile.ba50402.svg";